module.exports = __WEBPACK_EXTERNAL_MODULE_47__;


//////////////////
// WEBPACK FOOTER
// external "@angular/platform-browser"
// module id = 47
// module chunks = 0